import { useState } from "react";
import { API, formatDetail } from "./api";
import "./admin.css";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setBusy(true);
    setError("");
    try {
      const response = await fetch(`${API}/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ email, password }),
      });
      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        throw new Error(formatDetail(data.detail));
      }
      window.location.href = "/admin";
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="admin-login-shell" data-testid="admin-login-page">
      <form className="admin-login-card" onSubmit={submit} data-testid="admin-login-form">
        <a className="wordmark" href="/" data-testid="admin-login-wordmark"><span className="wordmark-dot" />ALCRISTAR</a>
        <p className="admin-login-sub">Admin console</p>
        <label>Email<input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
          placeholder="you@alcristar.in" data-testid="admin-email-input" /></label>
        <label>Password<input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
          placeholder="••••••••••••" data-testid="admin-password-input" /></label>
        {error && <p className="admin-error" data-testid="admin-login-error">{error}</p>}
        <button className="button button-dark" type="submit" disabled={busy} data-testid="admin-login-submit">
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
